// extracted by mini-css-extract-plugin
module.exports = {"nav_wrapper":"NavBar_nav_wrapper__VKHBQ","logo_wrapper":"NavBar_logo_wrapper__1NASn","links":"NavBar_links__JI_1b","hide_on_mobile":"NavBar_hide_on_mobile__oLA5s"};